import { Sesso } from "../enums/Sesso";
import { Roles } from "../enums/Roles";

export class User {
  id?: number;
  nome: string;
  cognome: string;
  email: string;
  username: string;
  password: string;
  birthDate: string;
  sesso: Sesso;
  peso?: number;
  altezza?: number;
  role: Roles;
  isActive: boolean;
  parentId?: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  expiring?: string;
  phoneNumber?: string;

  constructor() {
    this.nome = "";
    this.cognome = "";
    this.email = "";
    this.username = "";
    this.password = "";
    this.birthDate = "";
    this.sesso = Sesso.Empty;
    this.role = Roles.Empty;
    this.isActive = false;
    this.createdAt = "";
    this.updatedAt = "";
    this.deletedAt = "";
  }
}

export type UpdateUserDTO = {
  email?: string;
  username?: string;
  password?: string;
  peso?: number;
  altezza?: number;
  oldPassword?: string;
  passwordConfirmation?: string;
  expiring?: string | null;
  isActive?: boolean;
  phoneNumber?: string;
  role?: Roles;
};

export type LoginResponse = {
  responseCode: number;
  error?: any;
  user: User;
  accessToken: string;
  refreshToken: string;
};
